// @module Ames.PriorityBrandSort.PriorityBrandSort
define('Ames.PriorityBrandSort.PriorityBrandSort.View'
,	[
	'ames_prioritybrandsort_prioritybrandsort.tpl'
	
	,	'Ames.PriorityBrandSort.PriorityBrandSort.SS2Model'
	
	,	'Backbone'
    ]
, function (
	ames_prioritybrandsort_prioritybrandsort_tpl
	
	,	PriorityBrandSortSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class Ames.PriorityBrandSort.PriorityBrandSort.View @extends Backbone.View
	return Backbone.View.extend({

		template: ames_prioritybrandsort_prioritybrandsort_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new PriorityBrandSortModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Ames.PriorityBrandSort.PriorityBrandSort.View.Context
	,	getContext: function getContext()
		{
			//@class Ames.PriorityBrandSort.PriorityBrandSort.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
